import { GlobeAltIcon, PhoneIcon } from '@heroicons/react/outline';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Footer,
  Hyperlink
} from '@see-ui/core';
import { CheckCheck } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useGlobalStore } from '@services/store/global-store';
import * as footerContent from './AppFooter.content.json';
import * as ncFooterCoontent from './NCAppFooter.content.json';

const AppFooter: React.FC = () => {
  const userState = useGlobalStore(
    (state) => state.userDetails.userInformation.state
  );
  const { isNC, userDetails, isCarelonRx } = useGlobalStore((state) => state);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [content, setContent] = useState<any>(footerContent);
  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    console.log('Link clicked');
  };
  useEffect(() => {
    if (isNC) {
      setContent(ncFooterCoontent);
    }
  }, []);
  const handleContactUsClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    setIsDialogOpen(true);
  };

  const handleButtonClick = () => {
    window.open(
      'https://www.w3.org/WAI/standards-guidelines/wcag/',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <>
      <div
        className={`${
          isCarelonRx ? 'bg-[#E1EDFF] text-black' : 'bg-black text-white'
        } py-5 pl-40 pr-4`}
      >
        <div style={{ fontSize: 'smaller' }}>
          <div className="flex mb-7">
            <div className="flex-col" style={{ width: '80%' }}>
              <div className="fwc-footer-links">
                {!isNC && (
                  <p className="footer-link">
                    Developed With {isCarelonRx ? 'CarelonRx' : 'Anthem'}
                  </p>
                )}
              </div>
              <div className="fwc-footer-links">
                <Hyperlink
                  className="footer-link underline pr-5 text-blue-300 hover:text-blue-200 focus:text-blue-200 focus:outline-2 focus:outline-blue-200 focus:outline-offset-2"
                  children="Terms of Use"
                  href="#"
                  onClick={handleClick}
                />
                <Hyperlink
                  className="footer-link underline pr-5 text-blue-300 hover:text-blue-200 focus:text-blue-200 focus:outline-2 focus:outline-blue-200 focus:outline-offset-2"
                  children="Protecting Your Privacy"
                  href="#"
                  onClick={handleClick}
                />
              </div>
            </div>
            <div className="fwc-col-3 md-12">
              <div className="fwc-footer-flex-column">
                <Button
                  size="md"
                  variant="secondary"
                  className="underline custom-button text-blue-700 hover:text-blue-800"
                  style={{ fontSize: 'smaller' }}
                  onClick={handleButtonClick}
                  title="WCAG Standard Guidelines"
                  aria-label="WCAG"
                  data-analytics-name="WCAG 2.1 AA"
                  data-analytics="WCAG"
                  data-analytics-context="Footer"
                >
                  <CheckCheck /> WCAG 2.1 AA
                </Button>
              </div>
            </div>
          </div>
          <div>
            {userState === 'OH' && (
              <div className="footer-text-small">
                Anthem Blue Cross and Blue Shield Medicaid is the trade name of
                Community Insurance Company, an independent licensee of the Blue
                Cross and Blue Shield Association. Anthem is a registered
                trademark of Anthem Insurance Companies, Inc.
              </div>
            )}
            {userState === 'FL' && (
              <div className=" footer-text-small">
                Simply Healthcare Plans, Inc. is a Managed Care Plan with a
                Florida Medicaid contract.
              </div>
            )}
            {userState === 'VA' && (
              <div className="footer-text-small">
                Offered by HealthKeepers, Inc
              </div>
            )}
            {userState === 'KS' && (
              <div className="footer-text-small">
                Healthy Blue is the trade name of the Community Care Health Plan
                of Kansas, Inc., an independent licensee of the Blue Cross and
                Blue Shield Association
              </div>
            )}
            {userState === 'OH' && (
              <div className="footer-text-small">
                ©2022 Anthem Insurance Companies, Inc.
              </div>
            )}
            {userState === 'GA' && (
              <div className=" footer-text-small">
                © 2021 Amerigroup Corporation
              </div>
            )}
            {userState === 'NC' && (
              <div className=" footer-text-small">
                Healthy Blue Care Together is a Medicaid plan offered by Blue
                Cross and Blue Shield of North Carolina. Blue Cross and Blue
                Shield of North Carolina is an independent licensee of the Blue
                Cross Blue Shield Association. ® Marks of the Blue Cross Blue
                Shield Association. All other marks are the property of their
                respective owners.
              </div>
            )}
          </div>
        </div>
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogTrigger asChild></DialogTrigger>
          <DialogContent style={{ maxWidth: '900px' }}>
            <DialogHeader>
              <DialogTitle className="mb-4 text-2xl">Contact Us</DialogTitle>
              <DialogDescription className="text-left text-black text-lg">
                Get the support you need so you can focus on providing member
                care.
              </DialogDescription>
            </DialogHeader>
            <div className="bordered-box">
              <div className="flex mb-4">
                <div className="flex-col" style={{ width: '40%' }}>
                  <div style={{ display: 'flex' }}>
                    <PhoneIcon className="size-8 text-green-400 pr-3"></PhoneIcon>
                    Call Member Services at:{' '}
                  </div>
                </div>

                <div className="flex-col" style={{ width: '70%' }}>
                  <h6>844-912-0938 (TTY 711)</h6>
                  <h6>
                    Monday through Friday from 7 a.m. to 8 p.m. Eastern time.
                  </h6>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <GlobeAltIcon className="size-8 text-green-400 pr-3"></GlobeAltIcon>
                <h6>
                  For assistance with website issues, please call: 866-755-2680
                </h6>
              </div>
            </div>
            <DialogFooter className="md:justify-end">
              <DialogClose asChild>
                <Button type="button" variant="primary">
                  Close
                </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default AppFooter;
